import { CSSProperties, memo, useCallback } from "react";
import React, { ButtonHTMLAttributes, FC } from "react";

type Props = {
  isDark?: boolean;
  style?: CSSProperties;
  type: "buy" | "sell";
  onChangeTab: (type: "buy" | "sell") => void;
};

const TabsComponent: FC<Props> = ({ isDark, style, onChangeTab, type }) => {
  const activeColor = isDark ? "#000000" : "#E41E1F";
  const backgroundColor = isDark ? "#F8F8F8" : "#ffffff";

  const handleClick = useCallback<NonNullable<ButtonHTMLAttributes<HTMLButtonElement>["onClick"]>>(
    (event) => {
      if (event.target instanceof HTMLButtonElement) {
        onChangeTab((event.target.dataset.value as "buy" | "sell") ?? "buy");
      }
    },
    [onChangeTab]
  );

  return (
    <div
      style={{
        height: "64px",
        backgroundColor: backgroundColor,
        padding: "6px",
        borderRadius: "60px",
        gap: "6px",
        alignSelf: "center",
        display: "flex",
        ...style,
      }}
    >
      <button
        onClick={handleClick}
        style={{
          width: "110px",
          border: "none",
          outline: "none",
          borderRadius: "70px",
          fontSize: "15px",
          lineHeight: "115%",
          fontWeight: 900,
          color: type === "buy" ? "#ffffff" : undefined,
          backgroundColor: type === "buy" ? activeColor : backgroundColor,
        }}
        data-value="buy"
      >
        BUY
      </button>
      <button
        onClick={handleClick}
        data-value="sell"
        style={{
          width: "110px",
          border: "none",
          outline: "none",
          borderRadius: "70px",
          fontSize: "15px",
          lineHeight: "115%",
          fontWeight: 900,
          color: type === "sell" ? "#ffffff" : undefined,
          backgroundColor: type === "sell" ? activeColor : backgroundColor,
        }}
      >
        SELL
      </button>
    </div>
  );
};

export const Tabs = memo(TabsComponent);
